import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-completeness',
  styleUrls: ['./completeness.component.scss'],
  template: `<div class="pie no-round" [style.--percent]="completeness"></div> {{ completeness }}%`
})
export class CompletenessComponent {

  @Input()
  completeness: number;
}
